export default __webpack_public_path__ + "static/media/stock-inventory-management-vegshelf-marketplace.0a8c5841.png";